import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/strong

export const Strong = styled.strong``;
